package com.zaurh.mapquizwebsite.data.repository

import com.zaurh.mapquizwebsite.data.service.UserApi
import com.zaurh.mapquizwebsite.domain.model.UserDataDO
import com.zaurh.mapquizwebsite.domain.repository.UserRepository
import com.zaurh.mapquizwebsite.utils.Result
import com.zaurh.mapquizwebsite.utils.safeApiCall

class UserRepositoryImpl(
    private val api: UserApi
): UserRepository {
    override suspend fun getUserData(): Result<UserDataDO> {
        return safeApiCall { api.getUserData() }
    }
}